if (!customElements.get('pickup-store-info')) {
  const pending = new Map();
  let retryAfter = 0;
  function getSettings(url) {
    if (Date.now() < retryAfter) return Promise.reject(new Error('Rate limited'));
    if (pending.has(url)) return pending.get(url);
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 3000);
    const request = fetch(url, { signal: controller.signal, cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(async response => {
        if (response.status === 429) {
          const delay = Number(response.headers.get('Retry-After'));
          retryAfter = Date.now() + (Number.isFinite(delay) && delay > 0 ? delay : 60) * 1000;
        }
        if (!response.ok) throw new Error('Unavailable');
        const data = await response.json();
        if (data.ok !== true || data.contract_version !== 1 || !['ENABLED', 'DISABLED', 'UNCONFIGURED'].includes(data.status)) throw new Error('Invalid contract');
        return data;
      }).finally(() => { clearTimeout(timer); pending.delete(url); });
    pending.set(url, request);
    return request;
  }
  customElements.define('pickup-store-info', class extends HTMLElement {
    connectedCallback() {
      const generation = this.generation = (this.generation || 0) + 1;
      const output = this.querySelector('[data-pickup-hours]');
      if (!output) return;
      output.hidden = true;
      output.textContent = '';
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      getSettings(root + 'apps/plus2do-options/store-pickup').then(data => {
        if (!this.isConnected || generation !== this.generation) return;
        if (data.status !== 'ENABLED' || data.enabled !== true || data.location_gid !== 'gid://shopify/Location/' + this.dataset.locationId) return;
        if (data.hours?.timezone !== 'Asia/Tokyo' || typeof data.hours.display_text !== 'string' || !data.hours.display_text.trim()) return;
        output.textContent = data.hours.display_text;
        output.hidden = false;
      }).catch(() => {});
    }
    disconnectedCallback() { this.generation = (this.generation || 0) + 1; }
  });
}
